import { CdkStepper } from '@angular/cdk/stepper';
import { Component, HostBinding } from '@angular/core';

/**
 * `<labs-stepper>` provides a wizard-like workflow by dividing content into logical steps.
 * It is built on the foundation of the CDK stepper that is responsible for the logic that drives a stepped workflow.
 */
@Component({
  selector: 'labs-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  // This allows other components in our angular app to recognise our custom stepper component as a CdkStepper
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }]
})
export class StepperComponent extends CdkStepper {
  /**
   * @ignore
   */
  @HostBinding('attr.role') role = 'tablist';

  /**
   * @ignore
   */
  @HostBinding('attr.aria-orientation') ariaOrientation = 'horizontal';

  /**
   * @ignore
   */
  onClick(index: number): void {
    if (index === this.selectedIndex) {
      return;
    }

    this.selectedIndex = index;
  }
}
